import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Responsive } from 'semantic-ui-react';
import i18next from 'i18next';
import { calcItemInConstruction } from '../../../selectors';
import { setItemToCart } from '../../../actions';
import { attachCurrency } from '../../general/CurrencyFormat';

import './AddItemToCartButton.scss';

const AddItemToCartButton = () => {
    const dispatch = useDispatch();
    const itemInConstruction = useSelector(state => state.order.itemInConstruction);
    const { editMode, isValid, finalPrice, missingSelection } = useSelector(state => calcItemInConstruction(state));

    const renderButton = mobile => {
        const props = mobile ? { className: "pi approve" } : { primary: true, fluid: true };
        let content = editMode ? i18next.t('order.saveChanges') : i18next.t('order.addItem');
        const attentionMessage = missingSelection ? `${i18next.t('order.mustChoose', { name: missingSelection.name })}` : null;

        if (finalPrice) content += ` | ${attachCurrency(finalPrice)}`;
        if (mobile && attentionMessage) content = attentionMessage;

        return (
            <Fragment>
                <Button {...props} onClick={() => dispatch(setItemToCart(itemInConstruction))} disabled={!isValid}>
                    {content}
                </Button>
                {!mobile && attentionMessage ? <div style={{ textAlign: 'center', margin: 3, color: 'orangered' }}>{attentionMessage}</div> : null}
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Responsive minWidth={769}>
                {renderButton(false)}
            </Responsive>
            <Responsive maxWidth={768} className="add-item-wrapper" >
                {renderButton(true)}
            </Responsive>
        </Fragment>
    );
};

export default AddItemToCartButton;
